define('formkit/behavior/hide.not.progressively.disclosed.unchanged.objects.behavior',['require','exports','module','marionette'],function(require, exports, module) {
  var Mn = require('marionette');

  var HideNotProgressivelyDisclosedUnchangedObjectsBehavior = Mn.Behavior.extend({
    defaults: {
      form: null,
      model: null,
    },

    initialize: function() {
      this.listenToOnce(this.view, 'before:render', function() {
        this.hideNotProgressivelyDisclosedUnchangedObjects();
      });
    },

    hideNotProgressivelyDisclosedUnchangedObjects: function() {
      var model = this.getOption('model') || this.view.getOption('model');
      var form = this.getOption('form') || this.view.form;

      // show view if either template object is displayed already or if it is hidden and status is hidden
      // which means it is displayed on the other side of compare tool
      this.view.visible = form.util.isDisplayed(model) || form.util.isProgressivelyHidden(model);
    },
  });
  module.exports = HideNotProgressivelyDisclosedUnchangedObjectsBehavior;
});

